import { window } from '../../../../globals';
import { useToastedMutation } from '../../../../ReactQuery';
import { post } from '../../../../redux/api';
import { hardRedirectTo } from '../../../../utils';
import type { GitHubAppInstallUrlResponse, InstallUrlRequest } from '../../../../../shared/types/routes/vcs/githubApp';
import type { VcsApp } from '../../../../../shared/vcs/githubApp/apps';

const startGitHubAppInstall = async (app: VcsApp) => {
  // Send the current path so the install-callback returns the user here (the import page)
  // rather than the integrations settings page. Strip the transient `vcs_install` flag first so
  // it isn't round-tripped and accumulated on the URL each time the user installs another account.
  const params = new URLSearchParams(window.location.search);
  params.delete('vcs_install');
  const search = params.toString();
  const returnPath = `${window.location.pathname}${search ? `?${search}` : ''}`;
  const response = await post<InstallUrlRequest, GitHubAppInstallUrlResponse>(
    `/api/vcs/github-apps/${app}/install-url`,
    { returnPath },
  );
  return response.data as GitHubAppInstallUrlResponse;
};

/**
 * Asks vcs-service for a GitHub App install URL and redirects the user to it.
 * The install completes when GitHub redirects back to
 * `/api/vcs/github-apps/install-callback`.
 */
export function useStartGitHubAppInstall() {
  return useToastedMutation({
    mutationFn: startGitHubAppInstall,
    onSuccess: ({ installUrl }) => {
      hardRedirectTo(installUrl);
    },
    errorToastMessage: 'Failed to start GitHub App installation',
  });
}
